export function toLocalDateTimeString(utcValue) {
    if (!utcValue) return '';
    return new Date(utcValue).toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function toLocalDateTime(utcValue)  {
    if (!utcValue) return '';
    const date = new Date(utcValue);
    const offset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

// Convert local datetime-local format back to UTC ISO string
export function toUTCDateTime(localValue) {
    if (!localValue) return '';
    const date = new Date(localValue); // Local time as input
    return date.toISOString(); // Automatically converts to UTC
}

// Convert UTC datetime to a local date-only string (YYYY-MM-DD)
export function toLocalDate(utcValue) {
    if (!utcValue) return '';
    const date = new Date(utcValue);
    const offset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    return new Date(date.getTime() - offset).toISOString().slice(0, 10); // Extract date part
}

// Convert local date (YYYY-MM-DD) to a UTC datetime string with 12:00 time
export function toUTCDateWithNoon(localDate) {
    if (!localDate) return '';
    const date = new Date(`${localDate}T12:00:00`); // Set time to 12:00
    return date.toISOString(); // Convert to UTC
}

// Convert UTC datetime to a local date string in the browser's local format
export function toLocalDateString(utcValue) {
    if (!utcValue) return '';
    return new Date(utcValue).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });
}

